import { getUrlWithSearchParams, setErrorPage, useErrorPage } from "@helium10/re-core";
import { memo, useEffect, useState } from "react";
import styled from "styled-components";

import { useTranslation } from "../i18n/useTranslation";
import imageSrc from "../static/images/beige-dark-bg.svg";

export const ErrorPage = memo(() => {
  const { error } = useErrorPage();
  const { t } = useTranslation();

  // TODO What about another statuses?
  let message = error?.message;
  if (error?.code === 403) {
    message = t("error.403.title");
  } else if (error?.code === 404) {
    message = t("error.404.title");
  } else if (error?.code === 500) {
    message = t("error.500.title");
  }

  const redirectURL = error?.redirectURL || "/";

  // timer
  const [timeLeft, setTimeLeft] = useState(5);
  useEffect(() => {
    if (!timeLeft && error?.code === 403) {
      setErrorPage.clear();
      window.location.replace(getUrlWithSearchParams(redirectURL, {}));
      return;
    }

    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [error?.code, redirectURL, timeLeft]);

  return (
    <ErrorContainer>
      <ErrorContainerBox>
        <ErrorContainerHeader>
          <ErrorContainerLogo>
            <img src={imageSrc} alt="Helium 10" />
          </ErrorContainerLogo>
        </ErrorContainerHeader>
        <ErrorContainerContent>
          <ErrorContainerSorry>{t("error.sorry")}</ErrorContainerSorry>
          <ErrorContainerNumber>{error?.code}</ErrorContainerNumber>
          <ErrorContainerError>{message}</ErrorContainerError>

          {error?.code === 500 && (
            <ErrorContainerMessage dangerouslySetInnerHTML={{ __html: t("error.500.message") }} />
          )}

          {error?.code === 404 && (
            <ErrorContainerMessage dangerouslySetInnerHTML={{ __html: t("error.404.message") }} />
          )}

          {error?.code === 403 && (
            <ErrorContainerMessage>
              <Text dangerouslySetInnerHTML={{ __html: t("error.403.message") }} />
              <br />
              <span id="http-403-redirect-counter">
                {t("error.redirect", { count: timeLeft.toString() })}
              </span>
            </ErrorContainerMessage>
          )}

          <Button
            href={getUrlWithSearchParams(redirectURL, {})}
            className="btn btn-primary error-container__btn"
          >
            {t("error.backToDashboard")}
          </Button>
        </ErrorContainerContent>
      </ErrorContainerBox>
    </ErrorContainer>
  );
});

const ErrorContainer = styled.div`
  max-width: 488px;
  padding: 6% 15px 0;
  margin: auto;
  box-sizing: border-box;
`;

const ErrorContainerBox = styled.div`
  border-radius: 4px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
  background-color: #ffffff;
  overflow: hidden;
`;

const ErrorContainerHeader = styled.div`
  height: 94px;
  background-color: #003873;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ErrorContainerLogo = styled.a`
  max-width: 200px;

  & > img {
    display: block;
    width: 100%;
  }
`;

const ErrorContainerContent = styled.div`
  text-align: center;
  padding: 22px 15px 35px;
`;

const ErrorContainerSorry = styled.h3`
  font-size: 18px;
  font-weight: bold;
  color: #003873;
  margin-bottom: 6px;
`;

const ErrorContainerNumber = styled.h1`
  font-size: 84px;
  font-weight: 400;
  letter-spacing: 4px;
  color: #003873;
  line-height: 1em;
  margin-top: 0;
  margin-bottom: 18px;
`;

const ErrorContainerError = styled.div`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: #f64f45;
  margin-bottom: 36px;
  text-transform: uppercase;
`;

const ErrorContainerMessage = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #646464;
  margin-bottom: 63px;
`;

const Button = styled.a`
  line-height: 1.63;
  border-radius: 4px;
  text-decoration: none;
  display: inline-block;

  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: #ffffff;
  padding: 8px 15px;

  background-color: #003873;
  border-color: #003873;
  transition: all 0.3s ease;

  :hover,
  :focus,
  :active {
    box-shadow: none;
    outline: none;

    background-color: #3f5872;
    border-color: #3f5872;
    color: #ffffff;
  }
`;

const Text = styled.div``;
